module.exports = __webpack_public_path__ + "static/media/BlueFolder.b324c692.svg";